// Centralized dishes data - single source of truth
export const dishesData = [
{
  id: 1,
  name: "Bruschetta aux Champignons et Truffe",
  description: "Pain artisanal garni de champignons sauvages sautés, huile de truffe et parmesan vieilli",
  image: "https://images.unsplash.com/photo-1638525136572-f667b0d9e7ee",
  imageAlt: "Golden toasted bruschetta topped with sautéed wild mushrooms drizzled with truffle oil and shaved parmesan cheese on white ceramic plate",
  price: 12.99,
  originalPrice: null,
  category: 'appetizers',
  ingredients: ['Champignons sauvages', 'Huile de truffe', 'Parmesan', 'Pain artisanal', 'Ail', 'Herbes fraîches'],
  calories: 280,
  isNew: true,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 2,
  name: "Calamars Croustillants avec Aïoli",
  description: "Anneaux de calmar tendres légèrement panés et frits, servis avec aïoli à l'ail maison",
  image: "https://images.unsplash.com/photo-1727198826240-67e990b8de14",
  imageAlt: "Golden crispy fried calamari rings arranged on white plate with lemon wedges and creamy garlic aioli dipping sauce garnished with fresh parsley",
  price: 14.99,
  originalPrice: null,
  category: 'appetizers',
  ingredients: ['Calmar frais', 'Farine assaisonnée', 'Aïoli à l\'ail', 'Citron', 'Persil'],
  calories: 320,
  isNew: false,
  isPopular: true,
  isVegetarian: false,
  spiceLevel: 0
},
{
  id: 3,
  name: "Plateau Mezze Méditerranéen",
  description: "Assortiment de trempettes incluant houmous, baba ganoush et tzatziki avec pain pita chaud",
  image: "https://images.unsplash.com/photo-1602699043037-3a928edfe59b",
  imageAlt: "Colorful Mediterranean mezze platter featuring creamy hummus, smoky baba ganoush, and fresh tzatziki surrounded by warm pita triangles, olives, and cherry tomatoes on wooden board",
  price: 16.99,
  originalPrice: null,
  category: 'appetizers',
  ingredients: ['Houmous', 'Baba ganoush', 'Tzatziki', 'Pain pita', 'Olives', 'Tomates cerises'],
  calories: 380,
  isNew: false,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 4,
  name: "Saumon Grillé au Beurre aux Herbes",
  description: "Filet de saumon de l'Atlantique grillé à la perfection, garni de beurre composé aux herbes et légumes de saison",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1db4f71f7-1766755374470.png",
  imageAlt: "Perfectly grilled Atlantic salmon fillet with golden crispy skin topped with melting herb butter served alongside colorful roasted seasonal vegetables on elegant white plate",
  price: 28.99,
  originalPrice: 32.99,
  category: 'mains',
  ingredients: ['Saumon de l\'Atlantique', 'Beurre aux herbes', 'Asperges', 'Carottes miniatures', 'Citron', 'Aneth'],
  calories: 520,
  isNew: false,
  isPopular: true,
  isVegetarian: false,
  spiceLevel: 0
},
{
  id: 5,
  name: "Filet de Bœuf Wagyu",
  description: "Bœuf Wagyu japonais premium cuit à votre goût avec réduction au vin rouge et purée de pommes de terre à la truffe",
  image: "https://images.unsplash.com/photo-1644704265419-96ddaf628e71",
  imageAlt: "Succulent Wagyu beef tenderloin steak with perfect medium-rare center drizzled with rich red wine reduction sauce served with creamy truffle mashed potatoes and grilled vegetables",
  price: 58.99,
  originalPrice: null,
  category: 'mains',
  ingredients: ['Bœuf Wagyu', 'Réduction au vin rouge', 'Purée de pommes de terre à la truffe', 'Légumes de saison', 'Thym frais'],
  calories: 780,
  isNew: true,
  isPopular: true,
  isVegetarian: false,
  spiceLevel: 0
},
{
  id: 6,
  name: "Sauté de Poulet au Basilic Thaï",
  description: "Poulet sauté au wok avec basilic thaï, poivrons et piment dans une sauce savoureuse sur riz jasmin",
  image: "https://images.unsplash.com/photo-1643887259966-36834d3adc16",
  imageAlt: "Vibrant Thai basil chicken stir-fry with tender chicken pieces, colorful bell peppers, fresh Thai basil leaves in glossy savory sauce served over fluffy jasmine rice in traditional bowl",
  price: 22.99,
  originalPrice: null,
  category: 'mains',
  ingredients: ['Poitrine de poulet', 'Basilic thaï', 'Poivrons', 'Piment', 'Riz jasmin', 'Sauce soya', 'Sauce aux huîtres'],
  calories: 580,
  isNew: false,
  isPopular: true,
  isVegetarian: false,
  spiceLevel: 3
},
{
  id: 7,
  name: "Bol Bouddha Végétarien",
  description: "Base de quinoa avec légumes rôtis, avocat, pois chiches et vinaigrette au tahini",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_122675d96-1765285318929.png",
  imageAlt: "Colorful vegetarian Buddha bowl featuring fluffy quinoa base topped with roasted sweet potatoes, chickpeas, fresh avocado slices, mixed greens, and creamy tahini dressing in ceramic bowl",
  price: 18.99,
  originalPrice: null,
  category: 'mains',
  ingredients: ['Quinoa', 'Légumes rôtis', 'Avocat', 'Pois chiches', 'Tahini', 'Verdures mélangées', 'Graines'],
  calories: 480,
  isNew: true,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 8,
  name: "Linguine au Homard",
  description: "Queue de homard fraîche avec pâtes linguine dans une sauce au beurre à l\'ail et vin blanc",
  image: "https://images.unsplash.com/photo-1622644391772-1a64a17872ac",
  imageAlt: "Elegant lobster linguine pasta dish with succulent lobster tail pieces tossed in creamy white wine garlic butter sauce garnished with fresh parsley and parmesan on white plate",
  price: 42.99,
  originalPrice: null,
  category: 'mains',
  ingredients: ['Homard frais', 'Linguine', 'Vin blanc', 'Ail', 'Beurre', 'Persil', 'Parmesan'],
  calories: 680,
  isNew: false,
  isPopular: true,
  isVegetarian: false,
  spiceLevel: 0
},
{
  id: 9,
  name: "Gâteau Coulant au Chocolat",
  description: "Gâteau au chocolat chaud avec centre coulant, servi avec crème glacée à la vanille et compote de petits fruits",
  image: "https://images.unsplash.com/photo-1704980053735-e9e9f06ac1f0",
  imageAlt: "Decadent chocolate lava cake with flowing molten chocolate center served with scoop of vanilla ice cream and fresh berry compote drizzled with chocolate sauce on white dessert plate",
  price: 9.99,
  originalPrice: null,
  category: 'desserts',
  ingredients: ['Chocolat noir', 'Beurre', 'Œufs', 'Sucre', 'Farine', 'Crème glacée à la vanille', 'Petits fruits mélangés'],
  calories: 520,
  isNew: false,
  isPopular: true,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 10,
  name: "Tiramisu Classique",
  description: "Dessert italien traditionnel avec biscuits à la cuillère imbibés d\'espresso et crème au mascarpone",
  image: "https://images.unsplash.com/photo-1567588988863-bb7ca30a5914",
  imageAlt: "Classic Italian tiramisu dessert with layers of espresso-soaked ladyfingers and creamy mascarpone dusted with cocoa powder served in elegant glass dish with coffee beans garnish",
  price: 8.99,
  originalPrice: null,
  category: 'desserts',
  ingredients: ['Biscuits à la cuillère', 'Espresso', 'Mascarpone', 'Œufs', 'Sucre', 'Poudre de cacao', 'Vin Marsala'],
  calories: 380,
  isNew: false,
  isPopular: true,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 11,
  name: "Crème Brûlée",
  description: "Crème pâtissière soyeuse à la vanille avec croûte de sucre caramélisé et petits fruits frais",
  image: "https://images.unsplash.com/photo-1432139451555-f88aec4ce0bb",
  imageAlt: "Classic French crème brûlée with perfectly caramelized golden sugar crust over silky vanilla custard garnished with fresh raspberries and mint leaves in traditional ramekin",
  price: 8.99,
  originalPrice: null,
  category: 'desserts',
  ingredients: ['Crème épaisse', 'Gousse de vanille', 'Jaunes d\'œufs', 'Sucre', 'Petits fruits frais'],
  calories: 420,
  isNew: false,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 12,
  name: "Riz Gluant à la Mangue",
  description: "Riz gluant sucré au lait de coco avec tranches de mangue fraîche et graines de sésame grillées",
  image: "https://images.unsplash.com/photo-1561087701-13705d0139ca",
  imageAlt: "Traditional Thai mango sticky rice dessert with sweet coconut-infused glutinous rice topped with fresh ripe mango slices and toasted sesame seeds on banana leaf",
  price: 7.99,
  originalPrice: null,
  category: 'desserts',
  ingredients: ['Riz gluant', 'Lait de coco', 'Mangue fraîche', 'Sucre', 'Graines de sésame'],
  calories: 340,
  isNew: true,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 13,
  name: "Mojito Signature",
  description: "Menthe fraîche, lime, rhum blanc et eau gazeuse avec glace pilée",
  image: "https://images.unsplash.com/photo-1716301161843-5cc6247b7335",
  imageAlt: "Refreshing mojito cocktail in tall glass with fresh mint leaves, lime wedges, white rum, and crushed ice garnished with mint sprig and lime wheel",
  price: 11.99,
  originalPrice: null,
  category: 'beverages',
  ingredients: ['Rhum blanc', 'Menthe fraîche', 'Lime', 'Sucre', 'Eau gazeuse', 'Glace pilée'],
  calories: 180,
  isNew: false,
  isPopular: true,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 14,
  name: "Latté au Thé Vert Matcha",
  description: "Poudre de matcha japonais premium avec lait vapeur et miel",
  image: "https://images.unsplash.com/photo-1717425770920-6591212c0310",
  imageAlt: "Vibrant green matcha latte in clear glass cup with perfectly steamed milk creating beautiful layers topped with matcha powder art and served with bamboo whisk",
  price: 6.99,
  originalPrice: null,
  category: 'beverages',
  ingredients: ['Poudre de matcha', 'Lait vapeur', 'Miel', 'Eau chaude'],
  calories: 140,
  isNew: true,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
},
{
  id: 15,
  name: "Jus d\'Orange Fraîchement Pressé",
  description: "Jus d\'orange 100% pur fraîchement pressé sur commande",
  image: "https://images.unsplash.com/photo-1716834092549-7d8fd540b51a",
  imageAlt: "Glass of fresh squeezed orange juice with vibrant orange color served with orange slice garnish and fresh oranges in background on wooden table",
  price: 5.99,
  originalPrice: null,
  category: 'beverages',
  ingredients: ['Oranges fraîches'],
  calories: 110,
  isNew: false,
  isPopular: false,
  isVegetarian: true,
  spiceLevel: 0
}];


export default dishesData;